import { Component, OnInit } from '@angular/core';
import { UserDto, UserServiceProxy } from '@shared/service-proxies/service-proxies';
import { AlertController } from '@ionic/angular';
import { AppStorageService } from '@shared/storage/app-storage.service';
import { Router, NavigationExtras } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { Page } from 'src/model/page';
import { ColumnMode } from '@swimlane/ngx-datatable';

@Component({
  selector: 'app-users',
  templateUrl: './users.page.html',
  styleUrls: ['./users.page.scss'],
})
export class UsersPage implements OnInit {

  rows: UserDto[];
  page = new Page();
  ColumnMode = ColumnMode;
  sortTerm: string = 'lastName';
  sortDirection: string = 'ASC';
  user: string;
  isLoaded: boolean = false;
  constructor(
    private userSvc: UserServiceProxy,
    private alertController: AlertController,
    storageService: AppStorageService,
    private router: Router,
    private titleService: Title
  ) {
    this.titleService.setTitle('OACI - Users List');
    this.page.pageNumber = 0;
    this.page.size = 10;
    storageService.IsLoadedSubject.subscribe(x => { 
      if (!this.isLoaded && x) {
        this.getUsers();
        this.isLoaded = true;
      }
    });
  }

  ionViewWillEnter() {
    if (this.isLoaded) {
      this.getUsers();
    }
  }

  ngOnInit() {
    this.setPage({ offset: 0 });
  }

  search() {
    this.page.pageNumber = 0; // in case they are on another page and search filters to only one page
    this.getUsers();
  }

  getUsers() {
    this.userSvc.getAll(
      this.user,
      true,
      this.sortTerm + ' ' + this.sortDirection,
      this.page.pageNumber * this.page.size,
      this.page.size
    ).subscribe(response => {
      this.rows = response.items;
      this.page.totalElements = response.totalCount;
      this.page.totalPages = Math.ceil(response.totalCount / this.page.size);
    });
  }

  newUser() {
    this.router.navigate(['/main/user']);
  }

  editUser(id) {
    const navigationExtras: NavigationExtras = {
      queryParams: {
        userId: id
      }
    };
    this.router.navigate(['/main/user'], navigationExtras);
  }

  async deleteUser(id) {
    const alert = await this.alertController.create({
      header: 'Delete',
      message: 'Are you sure you want to delete this User?',
      buttons: [
        {
          text: 'Cancel',
          handler: () => {
            console.log('Confirm Okay');
          }
        },
        {
          text: 'Delete',
          cssClass: 'danger',
          handler: (blah) => {
            this.userSvc.delete(id).subscribe(() => {
              this.rows = this.rows.filter(x => x.id != id);
            });
          }
        }
      ]
    });

    await alert.present();
  }

  setPage(pageInfo) {
    this.page.pageNumber = pageInfo.offset;
    this.getUsers();
  }

  onSort(event) {
    this.sortTerm = event.column.prop;
    this.sortDirection = event.newValue.toUpperCase();
    this.getUsers();
  }

}
